import React from "react";
import './Background.css'
function Background(){
    return(
        <div className="Background">
        </div>
    )
};
export default Background;